<template>
	<div class="areaRank">
		areaRank
	</div>
</template>

<script>
	export default {
		name: 'areaRank'
	}
</script>

<style scoped>

</style>
